/**
 * @param {querySelector} burger - burger selector
 * @param {querySelector} menu - menu selector
 */

import calcProperties from "../utils/calcProperties";

function Mobilemenu(burgerClass, menuClass) {

    const burger = document.querySelector(burgerClass);
    const menu = document.querySelector(menuClass);
    this.burger = burger;
    this.menu = menu;

    if (!burger || !menu) return;

    burger.addEventListener("click", toggleBurger); 

    const host = this;
    function toggleBurger(e) {
        host.toggleBurger(e);
    }
}

Mobilemenu.prototype.toggleBurger = function(e){
    calcProperties.calcHeaderHeight();
    e.preventDefault();
    this.burger.classList.toggle("active");
    this.menu.classList.toggle("active");
    document.body.classList.toggle("mobilemenu-opened");
}

class Mobilemenu_krovelnyjstroymarket extends Mobilemenu{
    constructor(burgerClass, menuClass){
        super(burgerClass, menuClass);
        this.makeDropDown();
    }

    //Это всплывающее подменю
    makeDropDown(){
        const scrollMargin = 20;
        const menu_link_class = ".burger-menu__nav-link";
        const submenu_visible = "burger-menu__submenu--visible";
        const qMenuFilterBtn = ".burger-menu__filter-btn";
        const qBtnFilter = ".catalog__filter > .filter__btn"; //Прячем кнопку с фильтрами, если на странице нет этих элементов
        
        const html = document.querySelector("html");
        
        const menu_link = this.menu.querySelector(menu_link_class);
        const dropDown = menu_link.nextElementSibling;

        const touchContext = {
            touchStartAttached: false,
            touchStartStamp: 0,
            touchStart: false,
            touchDurationEdge: 800
        }
        if(typeof window.touchContext == "undefined"){
            window.touchContext = touchContext;
        }
        if(menu_link){
            if(!window.touchContext.touchStartAttached){
                menu_link.addEventListener("touchstart", onTouchStart);
                menu_link.addEventListener("mousedown", onTouchStart);
                menu_link.addEventListener("touchend", onTouchEnd);
                menu_link.addEventListener("mouseup", onTouchEnd);
                document.addEventListener("touchstart", onHide);
                document.addEventListener("mousedown", onHide);
                window.touchContext.touchStartAttached = true;
            }
        }else{
            console.error(`Can't find ${menu_link_class}`);
        }

        //TODO: Кандидат на отдельный метод
        const menuFilterBtn = this.menu.querySelector(qMenuFilterBtn);
        const btnFilter = document.querySelector(qBtnFilter);
        //console.log(btnFilter);
        if(!btnFilter){
            if(menuFilterBtn)menuFilterBtn.style.display = "none";
        }else{
            if(menuFilterBtn){
                menuFilterBtn.addEventListener("click", (e) => {
                    e.stopPropagation();
                    this.burger.click(); //Закрыть меню
                    btnFilter.click(); //Открыть фильтры в каталоге
                    const header = document.querySelector(".header-fixed .header__bottom");
                    let hHeight = 0;
                    if(header)hHeight = header.getBoundingClientRect().height;
                    html.scrollTop = (btnFilter.getBoundingClientRect().top + window.scrollY - hHeight - scrollMargin);
                });
            }
        }

        function onTouchStart(e){
            if(body.getAttribute("data-ctx") !== 'krovelnyjstroymarket')return;
            e.preventDefault();
            e.stopPropagation();
            window.touchContext.touchStartStamp = e.timeStamp;
            window.touchContext.touchStart = true;
            //console.log(dropDown.classList);
            if(dropDown)dropDown.classList.toggle(submenu_visible);
            checkLinkTransition();
        }
    
        function onTouchEnd(e){
            if(body.getAttribute("data-ctx") !== 'krovelnyjstroymarket')return;
            e.preventDefault();
            e.stopPropagation();
            window.touchContext.touchStart = false;
        }
    
        function onHide(e){
            if(!dropDown || dropDown.contains(e.target))return;//console.log("ok!");
            dropDown.classList.remove(submenu_visible);
        }
    
        function checkLinkTransition(){
            const m = performance.measure("q", {start: window.touchContext.touchStartStamp});
            if(m.duration > window.touchContext.touchDurationEdge){
                location.href = menu_link.getAttribute("href");
                window.touchContext.touchStart = false; 
            }
            if(window.touchContext.touchStart)setTimeout(checkLinkTransition, 200);
        }

    }
}

export {
    Mobilemenu,
    Mobilemenu_krovelnyjstroymarket
}